import { Link } from "react-router-dom";
import { Panel } from "@/components/admin/AdminUI";
import { countryName } from "@/lib/countries";
import { formatDate, humanize } from "@/lib/format";

const yes = (v) => (v ? "Yes" : "No");
const list = (v) => (v?.length ? v.map(humanize).join(", ") : "None");
const txt = (v) => (v == null || v === "" ? "—" : String(v));

function Facts({ title, rows, testId }) {
  return (
    <div data-testid={testId}>
      <h3 className="cw-muted mb-3 text-xs font-medium uppercase tracking-wide">{title}</h3>
      <dl className="grid grid-cols-[minmax(0,10rem)_1fr] gap-x-4 gap-y-2 text-sm">
        {rows.map(([k, v]) => <div key={k} className="contents"><dt className="cw-soft">{k}</dt><dd className="min-w-0 break-words" data-testid={`${testId}-${k.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{v}</dd></div>)}
      </dl>
    </div>
  );
}

// No raw coordinates anywhere: the API returns only "has coordinates" and the source.
const locationRows = (l) => [
  ["City", txt(l.city)], ["Postal code", txt(l.postal_code)], ["State / province", txt(l.state)], ["Country", l.country ? `${countryName(l.country)} (${l.country})` : "—"],
  ["Region status now", txt(l.region_status_now && humanize(l.region_status_now))], ["Matched rule", l.region_rule_matched ? <span className="font-mono text-xs">{l.region_rule_matched}</span> : "—"],
  ["Area", txt(l.area)], ["At signup", txt(l.signup_region_status && humanize(l.signup_region_status))],
  ["Discover paused", yes(l.discover_paused)], ["Hard blocked", yes(l.hard_blocked)],
  ["Last refresh", l.last_refresh_at ? formatDate(l.last_refresh_at) : "Never"], ["Has coordinates", yes(l.has_coordinates)],
  ["Coordinates from", txt(l.coordinates_source)], ["Distance measured from", txt(l.distance_from)], ["Refresh source", txt(l.location_refresh_source && humanize(l.location_refresh_source))],
];
const settingsRows = (s) => [
  ["Age", txt(s.age)], ["Gender", txt(s.gender && humanize(s.gender))], ["Show me", txt(s.show_me && humanize(s.show_me))],
  ["Age range", txt(s.age_range)], ["Distance", txt(s.distance)], ["Plan", txt(s.plan && humanize(s.plan))],
  ["Filters in use", list(s.filters_in_use)], ["Hard no's on", list(s.hard_nos_on)], ["Verification", txt(s.verification && humanize(s.verification))],
  ["Onboarding complete", yes(s.onboarding_complete)], ["Status", txt(s.status && humanize(s.status))], ["Last active", s.last_active_at ? formatDate(s.last_active_at) : "Never"],
];

export default function MemberPanel({ who, m, testId }) {
  return (
    <Panel className="space-y-6 p-6" data-testid={testId}>
      <div><p className="cw-muted text-xs">{who}</p>
        <h2 className="text-lg font-semibold">{m.name || "No name yet"}</h2>
        <Link to={`/admin/users/${m.id}`} className="cw-brand-deep font-mono text-xs underline-offset-4 hover:underline" data-testid={`${testId}-link`}>{m.id}</Link></div>
      <Facts title="Location" rows={locationRows(m.location || {})} testId={`${testId}-location`} />
      <Facts title="Settings" rows={settingsRows(m.settings || {})} testId={`${testId}-settings`} />
    </Panel>
  );
}
